import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import PresentationCheckboxes from "./components/PresentationCheckboxes";
import PresentationDropdown from "./components/PresentationDropdown";
import PresentationScale from "./components/PresentationScale";
import PresentationKeyboard from "./components/PresentationKeyboard";
import ReactDOM from 'react-dom';
import scrollToComponent from "react-scroll-to-component";

class Single extends Component {

  constructor(props) {
    super(props);

    this.handlerDetailsUpdated = this.handlerDetailsUpdated.bind(this);
  }

  handlerDetailsUpdated(details){
    this.props.onDetailsUpdated(details).then(() => {
      if (this.props.question.goToNextOnFill) {
        if (this.props.isLastOnPage) {
          this.props.changePage(1);
        } else {
          const rects = ReactDOM.findDOMNode(this).getBoundingClientRect();
          scrollToComponent(this, {align: 'top', offset: rects.height + 30});
        }
      }
    });
  }

  presentationType(){
    const {details, question, changePage} = this.props;
    const {answers, answersColumns, answersImage, presentationType} = this.props.question;

    const defaultProps = {
      question,
      answersImage,
      details,
      answers,
      answersColumns,
      onDetailsUpdated: this.handlerDetailsUpdated,
      changePage,
    };

    switch (presentationType) {
      case 'checkboxes':
        return <PresentationCheckboxes
          {...defaultProps}
        />;
      case 'dropdown':
        return <PresentationDropdown
          {...defaultProps}
          isSearchable={false}
        />;
      case 'dropdownFilter':
        return <PresentationDropdown
          {...defaultProps}
          isSearchable={true}
        />;
      case 'scale':
        return <PresentationScale
          {...defaultProps}
          isSearchable={true}
        />;
      case 'keyboard':
        return <PresentationKeyboard
          {...defaultProps}
        />;
    }
  }

  validate(){
    const {details, validationTexts} = this.props;
    const {answers, required} = this.props.question;

    let validate = {
      valid: true,
      errors: []
    };

    if(required && _.isEmpty(details)){
      validate.errors.push(validationTexts.required);
    }

    if(!_.isEmpty(details)){
      const answer = answers.find(ans => ans.id === parseInt(details[0].answer));
      const content = details[0].content;

      if(answer.isOpen && _.isEmpty(content) && !answer.openIsNotRequired){
        validate.errors.push(validationTexts.detail.answerContentEmpty);
      }
    }

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render(){
    return this.presentationType();
  }
}

Single.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
      openIsNotRequired: PropTypes.bool.isRequired,
    }),).isRequired,
    answersColumns: PropTypes.number,
    answersImage: PropTypes.bool.isRequired,
    presentationType: PropTypes.oneOf(['checkboxes', 'dropdown', 'dropdownFilter', 'scale', 'keyboard']).isRequired,
    required: PropTypes.bool.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    content: PropTypes.string,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string.isRequired,
    answerContentEmpty: PropTypes.string,
  }).isRequired,
  changePage: PropTypes.func.isRequired,
  isLastOnPage: PropTypes.bool.isRequired
};

export default connect((state, props) => {
  return {
    details: _.find(state.questionResponses, questionResponse => questionResponse.question === props.id).details
  }
}, null, null, {withRef: true, forwardRef: true})(Single);